import React, { useState } from "react";
import { MainTopBar } from "../components/main-top-bar/main-tob-bar.component";
import { SideMenu } from "../components/side-menu/side-menu.component";
import BottomNavigation from "../components/bottom-navigation/bottom-navigation.component";
import clsx from "clsx";

function MainLayout({ children, hasBottomNavigation }) {
	const [isMenuOpen, setIsMenuOpen] = useState(false);

	const onMenuToggle = () => {
		setIsMenuOpen((prev) => !prev);
	};

	const isBottomNavigationVisible = hasBottomNavigation && !isMenuOpen;

	return (
		<>
			<div
				className={clsx("main-layout", {
					"content-with-bottom-navigation ": isBottomNavigationVisible,
				})}
			>
				<MainTopBar onMenuClick={onMenuToggle} isOpen={isMenuOpen} />
				<div className="main-layout-content">
					<SideMenu isOpen={isMenuOpen} />
					{children}
				</div>
			</div>

			{isBottomNavigationVisible && (
				<div className="bottom-navigation-menu-holder">
					<BottomNavigation />
				</div>
			)}
		</>
	);
}

export default MainLayout;
